module.exports = __webpack_public_path__ + "img/compliance_uncheck.a506dfb0.svg";